<template>
  <div class="admins-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header :title="`${adminId ? 'Editar' : 'Cadastrar'} Usuário`">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'admins.index' }"
      >
        <b-icon size="is-small" icon="arrow-left" />Voltar
      </button>
    </app-page-header>
    <app-card>
      <admin-form
        @submit="onSubmit"
        :id="adminId"
        :errors="errors"
        :saving="isSaving"
      ></admin-form>
    </app-card>
  </div>
</template>

<script>
import AdminForm from '@/components/Forms/AdminForm.vue';
import AdminService from '@/services/admin.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'admin-form-page',
  mixins: [ToastMixin],
  components: {
    AdminForm,
  },
  data: () => {
    return {
      adminId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.errors = {};
      !this.adminId && this.save(data);
      this.adminId && this.update(this.adminId, data);
    },
    save(data) {
      this.isSaving = true;
      AdminService.save(data)
        .then(() => {
          this.toastify('Usuário cadastrado com sucesso!');
          this.$router.push({ name: 'admins.index' });
        })
        .catch(({ response }) => {
          if (response.status === 422) this.errors = response.data.errors;
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, data) {
      this.isSaving = true;
      delete data.created_at;
      delete data.updated_at;
      delete data.user.created_at;
      delete data.user.updated_at;
      AdminService.update(id, data)
        .then(() => {
          this.toastify('Usuário atualizado com sucesso!');
          this.$router.push({ name: 'admins.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Usuário.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.adminId = this.$route.params.id;
  },
};
</script>

<style lang="scss" scoped></style>
